<h3 translate="CustomerNew.ConfirmNewCustomerRegistration" class="mb-3"></h3>
<ng-container *ngIf="!job; else jobTemplate">

    <div id="confirmDetails">
        <h4 translate="Job.Contact"></h4>
        <hr />

        <dl class="row">
            <dt class="col-3" translate="Contact.Title"></dt>
            <dd class="col-9">{{ contact.title }}</dd>

            <dt class="col-3" translate="Contact.FirstName"></dt>
            <dd class="col-9">{{ contact.firstName }}</dd>

            <dt class="col-3" translate="Contact.LastName"></dt>
            <dd class="col-9">{{ contact.lastName }}</dd>

            <dt class="col-3" translate="Contact.EmailAddress"></dt>
            <dd class="col-9">{{ contact.emailAddress }}</dd>

            <dt class="col-3" translate="Contact.Mobile"></dt>
            <dd class="col-9">{{ contact.mobile }}</dd>

            <dt class="col-3" translate="Contact.OfficeHours"></dt>
            <dd class="col-9">{{ contact.officeHours }}</dd>

            <dt class="col-3" translate="Contact.AfterHours"></dt>
            <dd class="col-9">{{ contact.afterHours }}</dd>
        </dl>

        <h4 translate="Job.Machine"></h4>
        <hr />
        <dl class="row">
            <dt class="col-3" translate="Machine.ModelID"></dt>
            <dd class="col-9">{{ machine.modelId }}</dd>

            <dt class="col-3" translate="Machine.MachineName"></dt>
            <dd class="col-9">{{ machine.name }}</dd>

            <dt class="col-3" translate="Machine.Serial"></dt>
            <dd class="col-9">{{ machine.serialNumber }}</dd>

            <dt class="col-3" translate="Machine.DateOfPurchase"></dt>
            <dd class="col-9">{{ machine.dateOfPurchase|date }}</dd>

            <ng-container *hasTranslation="'Machine.Field1'">
                <dt class="col-3" translate="Machine.Field1"></dt>
                <dd class="col-9">{{ machine.fields[0] }}</dd>
            </ng-container>
            <ng-container *hasTranslation="'Machine.Field2'">
                <dt class="col-3" translate="Machine.Field2"></dt>
                <dd class="col-9">{{ machine.fields[1] }}</dd>
            </ng-container>
            <ng-container *hasTranslation="'Machine.Field3'">
                <dt class="col-3" translate="Machine.Field3"></dt>
                <dd class="col-9">{{ machine.fields[2] }}</dd>
            </ng-container>
            <ng-container *hasTranslation="'Machine.Field4'">
                <dt class="col-3" translate="Machine.Field4"></dt>
                <dd class="col-9">{{ machine.fields[3] }}</dd>
            </ng-container>
            <ng-container *hasTranslation="'Machine.Field5'">
                <dt class="col-3" translate="Machine.Field5"></dt>
                <dd class="col-9">{{ machine.fields[4] }}</dd>
            </ng-container>

            <dt class="col-3" translate="Machine.BranchID"></dt>
            <dd class="col-9" [abiLookupdisplay]="machine.dealerBranchId" listName="DealerBranch"></dd>

            <dt class="col-3" translate="Machine.Attachment"></dt>
            <dd class="col-9">{{ getFileNames(files).join(', ') }}</dd>
        </dl>
    </div>
</ng-container>
<ng-template #jobTemplate>
    <abi-jobs-confirm
        [showTitle]="false"
        [job]="job"
        [files]="files"
        [displaySections]="['contact', 'address', 'machine', 'dealer']"
    ></abi-jobs-confirm>
</ng-template>
